import Dispatcher from "../Dispatcher";
import FixtureApi from "./FixtureApi";

class FixtureDataManager {

    public async getFixture(fixtureId: number): Promise<any> {
        try {
            const response = await FixtureApi.getFixture(fixtureId);

            Dispatcher.dispatch({
                type: "fixture/loaded",
                fixture: response
            });
        }
        catch (error) {
            Dispatcher.dispatch({
                type: "fixture/error",
                error
            });
        }
    }

    public async getFixtures(from: number, to: number, requestId: string): Promise<any> {
        try {
            const response = await FixtureApi.getFixtures(from, to);
            Dispatcher.dispatch({
                type: "fixtures/loaded",
                fixtures: response,
                from,
                to,
                requestId: requestId
            });
        }
        catch (error) {
            Dispatcher.dispatch({
                type: "fixtures/error",
                error
            });
        }
    }

    public async getFixturesRefresh(from: number, to: number, requestId: string): Promise<any> {
        try {
            const requestReceived: Date = new Date();
            const response = await FixtureApi.getFixtures(from, to);
            Dispatcher.dispatch({
                type: "fixtures/refreshed",
                fixtures: response,
                requestId: requestId,
                from: from,
                to: to,
                timeStamp: requestReceived
            });
        }
        catch (error) {
            Dispatcher.dispatch({
                type: "fixtures/error",
                error
            });
        }
    }
}
export default new FixtureDataManager();
